module.exports = __webpack_public_path__ + "static/colors-utility-do-affbc0a38102ecfdee75463906ee49fc.png";